<script setup lang="ts">
import type { User } from 'src/modules/User/models/User';
import { startCase } from 'shared/utilities/string';
import { mdiAccountCancel, mdiAccountCheck } from '@quasar/extras/mdi-v7';

interface Props {
  currentUser: Partial<User>;
}

defineProps<Props>();

// defineProps<Props>()

// defineEmits<{
//   // (event: 'update:modelValue', payload: string): void
// }>()
</script>

<template>
  <q-list>
    <q-item>
      <q-item-section
        avatar
        class="text-center"
      >
        <q-avatar
          size="xl"
          font-size="1.5rem"
          color="primary"
          style="text-transform: uppercase"
        >
          {{ currentUser?.children?.[0]?.firstname?.charAt(0).toUpperCase()
          }}{{ currentUser?.children?.[0]?.lastname?.charAt(0).toUpperCase() }}
        </q-avatar>
      </q-item-section>

      <q-item-section>
        <q-item-label>{{
          startCase(
            `${currentUser?.children?.[0]?.firstname} ${currentUser?.children?.[0]?.lastname}`,
          )
        }}</q-item-label>
        <q-item-label
          caption
          class="text-grey-6"
        >
          {{ currentUser?.role?.type?.toUpperCase() }}
        </q-item-label>
      </q-item-section>
      <q-item-section side>
        <q-icon
          color="accent"
          :name="
            currentUser?.children?.[0]?.is_active
              ? mdiAccountCheck
              : mdiAccountCancel
          "
        />
      </q-item-section>
    </q-item>
    <q-separator dark />
    <q-item>
      <q-item-section>
        <q-item-label class="text-subtitle2 q-mt-sm">
          <q-chip
            color="primary"
            dense
            class="chip-width"
            >School</q-chip
          >
          {{ currentUser?.children?.[0]?.school }}
        </q-item-label>
        <q-item-label class="text-subtitle2">
          <q-chip
            color="primary"
            dense
            class="chip-width"
            >Class</q-chip
          >
          {{ currentUser?.children?.[0]?.class }}
        </q-item-label>
      </q-item-section>
    </q-item>
  </q-list>
</template>
